import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import './SelectorDropDown.css';

class SelectorDropDown extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    dataTestLabel: PropTypes.string,
    tabIndex: PropTypes.string,
    placeHolder: PropTypes.string,
    customComponentClass: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    preSelection: PropTypes.bool,
    checkPrevProps: PropTypes.bool,
    handleChangeOnUpdate: PropTypes.bool,
    isSearchable: PropTypes.bool,
    isValid: PropTypes.bool,
    isBlocked: PropTypes.bool,
    edited: PropTypes.bool,
    readOnly: PropTypes.bool,
    isDisabled: PropTypes.bool,
    stopPropagation: PropTypes.bool,
    dirtyEvent: PropTypes.func,
    handleSelectOption: PropTypes.func,
  }

  static defaultProps = {
    title: '',
    dataTestLabel: 'data-test-id-selector-dropdown',
    tabIndex: '',
    placeHolder: translate('placeHolderSelector'),
    customComponentClass: '',
    options: [],
    defaultValue: '',
    preSelection: true,
    checkPrevProps: false,
    handleChangeOnUpdate: false,
    isSearchable: true,
    isValid: true,
    isBlocked: false,
    edited: false,
    readOnly: false,
    isDisabled: false,
    stopPropagation: false,
    dirtyEvent: () => {},
    handleSelectOption: () => {}
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: this.props.options.filter(option => option.value === this.props.defaultValue)[0],
      inEdition: false
    };
  }

  componentDidMount() {
    const { preSelection, defaultValue, options } = this.props;

    if (!preSelection) return;

    if (options && options.length === 1 && defaultValue === '') {
      this.handleChange(options[0]);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      checkPrevProps,
      defaultValue,
      preSelection,
      options
    } = this.props;

    if (!checkPrevProps) {
      return;
    }

    if (prevProps.defaultValue === defaultValue 
      && prevProps.options === options) {
      return;
    }

    if (preSelection && options.length === 1 && defaultValue === '') {
      this.handleChange(options[0]);
      return;
    }

    if (options.length === 0 || defaultValue === '') {
      this.setStateOnly('');
      return;
    }

    this.setFilteredStateByValue(defaultValue);
  }

  setEditionMode = () => {
    this.setState({
      inEdition: true
    });
  }

  closeEditionMode = () => {
    this.setState({
      inEdition: false
    });
  }

  setFilteredStateByValue = (value) => {
    const { options, handleChangeOnUpdate, readOnly } = this.props;

    const filteredValue = options.filter(
      i => (i.value === value)
    );

    if (filteredValue && filteredValue[0]) {
      this.setStateOnly(filteredValue[0]);
      return;
    }

    if (!readOnly && handleChangeOnUpdate) {
      this.props.handleSelectOption('');
      return;
    }

    this.setStateOnly('');
  }

  setStateOnly = (selectedOption) => {
    const { stopPropagation } = this.props;

    if (stopPropagation) return;

    this.setState({
      selectedOption
    });
  }

  handleChange = (selectedOption) => {
    const { stopPropagation } = this.props;

    if (stopPropagation){
      this.props.dirtyEvent();
      return;
    }

    this.setState({ selectedOption }, () => {
      this.props.handleSelectOption(selectedOption.value);
    });
  }

  handleCustomInputClasses = () => {
    const { inEdition } = this.state;

    const { isValid, edited, isDisabled } = this.props;

    let inputClasses = "custom-select-component";

    if (!isValid) inputClasses = `${inputClasses} invalid-select`;

    if (edited) inputClasses = `${inputClasses} edited`;

    if (inEdition) inputClasses = `${inputClasses} edition-mode`;

    if (isDisabled) inputClasses = `${inputClasses} dirty-prevent`;

    return inputClasses;
  }

  render() {
    const {
      title,
      dataTestLabel,
      options,
      readOnly,
      isDisabled,
      isSearchable,
      placeHolder,
      customComponentClass,
      isBlocked,
      tabIndex,
      defaultValue
    } = this.props;

    const { selectedOption } = this.state;

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#FFF' : '#201E4B',
        background: state.isSelected ? '#201E4B' : ''
      })
    };

    const customComponentClasses = `selector-dropdown-component auto-margin ${customComponentClass} ${(isBlocked) ? 'dirty-prevent' : ''}`;

    return (
      <Row className={customComponentClasses}>
        {title !== '' && (
          <Col sm="12" className="component-title no-padding-left">{title}</Col>
        )}
        <Col sm="12" className="component-form no-padding-left" data-test-id={dataTestLabel}>
          {(readOnly)
            ?
              <label className="read-only-label">
                {(!selectedOption) ? defaultValue : selectedOption.label}
              </label>
            :
              <Select
                menuPlacement="auto"
                tabIndex={tabIndex}
                classNamePrefix="react-select-custom"
                className={this.handleCustomInputClasses()}
                value={selectedOption}
                onChange={this.handleChange}
                options={options}
                styles={customStyles}
                isSearchable={isSearchable}
                placeholder={placeHolder}
                isDisabled={isDisabled}
                onMenuOpen={this.setEditionMode}
                onMenuClose={this.closeEditionMode}
              />
          }
        </Col>
      </Row>
    );
  }
}

export default SelectorDropDown;
